// extracted by mini-css-extract-plugin
export var messageSideLeft = "_nn-1";
export var stateContainer = "_nn-0";